<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-trash-can-outline" inline class="ml-0 px-5 py-4" title="Expurgos de BDGD">
      <v-btn
        v-if="accessReleased('EXPURGOS_DE_BDGD_ADICIONAR')"
        id="btn-novo-expurgo"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('add')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Novo Expurgo de BDGD
      </v-btn>
      <v-text-field
        id="expurgo-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <v-divider class="mt-10" />
      <v-data-table
        class="expurgos-bdgd-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        :loading="loading"
        :hide-default-header="loading"
        :hide-default-footer="loading"
        no-data-text="Nenhum expurgo disponível"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.tabelas`]="{ item }">
          <div id="expurgo-column-entity" class="clickable-item" @click="openDialogTabelas(item.tabelas)">
            {{ item.tabelas | handleTabelasColumnValue }}
          </div>
        </template>
        <template v-slot:[`item.numero_linhas`]="{ item }">
          {{ item.numero_linhas | parseNumberToIntegerBR }}
        </template>
        <template v-slot:[`item.data_registro`]="{ item }">{{ item.data_registro | formatToMonth }} v{{ item.versao }}</template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="expurgo-log-criacao"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            @click="
              ((dialogCreationLog = true),
              (dialogCreationLogData = {
                username: item.usuario,
                created: item.created
              }))
            "
          >
            <v-icon medium>mdi-table-search</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar os bancos de dados de geoperdas</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
    <v-dialog v-model="dialogTabelas" scrollable max-width="500px">
      <v-card>
        <v-card-title class="py-3" style="text-align: left !important">
          <h4>Entidades</h4>
        </v-card-title>
        <v-divider />
        <v-card-text>
          {{ getTabelasConcat }}
        </v-card-text>
        <v-divider />
        <v-card-actions style="text-align: right !important; display: block !important">
          <v-btn color="green darken-1" @click="dialogTabelas = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
  import ExpurgosService from '@/services/ExpurgosService';
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';

  export default {
    components: {
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue')
    },

    filters: {
      handleTabelasColumnValue(arrayTabelas) {
        let formattedValue = arrayTabelas[0].toUpperCase();
        let lengthArray = arrayTabelas.length;
        formattedValue = lengthArray > 1 ? `${formattedValue} + ${lengthArray - 1}` : formattedValue;
        return formattedValue;
      }
    },
    mixins: [powerupsActionsMixins, profilePermissionsMixin],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    data: () => ({
      powerupService: ExpurgosService,
      powerupEntityName: 'Expurgo BDGD',
      dialogTabelas: false,
      dialogTabelasData: [],
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Empresa',
          value: 'empresa'
        },
        {
          text: 'Mês dos dados',
          value: 'data_registro'
        },
        {
          text: 'Entidades',
          value: 'tabelas'
        },
        {
          text: 'Nº de linhas',
          value: 'numero_linhas'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ]
    }),

    computed: {
      getTabelasConcat() {
        return this.dialogTabelasData.join(', ').toUpperCase();
      }
    },

    methods: {
      openDialogTabelas(arrNameTables) {
        this.dialogTabelasData = arrNameTables;
        this.dialogTabelas = true;
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .expurgos-bdgd-table tr td:nth-child(7),
    .expurgos-bdgd-table tr td:nth-child(8) {
      white-space: nowrap !important;
    }
  }
</style>
